import { LegalAgreementContent } from '../../content.types';

export const summerHealthLegalAgreement: LegalAgreementContent = {
  title: 'Summer Health Membership Agreement',
  intro:
    'By continuing, you agree to our membership terms and acknowledge our privacy practices.',
  body: `By signing up for Summer Health, you agree to:

- The Summer Health Terms of Service
- The Summer Health Privacy Policy
- Receive communications from Summer Health about your care

Your provider may share information with your care team to coordinate care. You can withdraw consent at any time by contacting support@summerhealth.com.`,
  cta: 'I agree',
};

export const legalAgreements: Record<string, LegalAgreementContent> = {
  '4BDFp2pv0kYWagOUt7e2ps': summerHealthLegalAgreement,
};
